import React from 'react';
import '../../App.css';

function About() {
    return (
        <>
        <section className='bg-[#FAF4FD]'>
            <div className='container pt-5 '>
                <div className='flex flex-col relative container ml-0  md:ml-[34px] text-center items-center gap-[174px]'>
                    <div className=''>
                        <p className='text-[#214B32] font-medium text-base mt-6 mb-6 md:mb-10 uppercase'>CAREERS</p>
                        <p className='section-head-main mt-6 md:mt-10 mb-4 md:w-[609px]'>We’re looking for super stars to build the future of urban living with</p>
                    
                    </div>
                    <div className='flex md:justify-between w-full'>
                        <img src='/images/careers.png' className='mx-auto bottom-0'/>
                    </div>
                    {/* <img src='/images/newHomePic.png' className=''/> */}
                </div>
            </div>
        </section>
        <div className='mt-[120px] container bg-white flex flex-col gap-20'>
            <section className='mb-10'>
                <p className='text-center section-head-main md:w-[683px] md:mx-auto mb-12'>Open Roles</p>
                <p className='text-center text-[#214B32] font-normal text-lg md:mx-auto mb-12'>While we do not have any openings now, if you would like to work with us feel free to send your resume to <a href="mailto:team@bubble.africa" className='text-[#439764]'>team@bubble.africa</a></p>
            </section>
        </div>
    </>
    )
}

export default About;

